import {
  EVENT_ACTION_ADD,
  EVENT_ACTION_FOLLOW,
  EVENT_CATEGORY_ADD_STUDENTS,
  EVENT_TARGET_TYPE_BANNER,
  EVENT_TARGET_TYPE_CTA,
  EVENT_TARGET_TYPE_MODAL,
} from 'approot/shared/data-tracker/data-events.constants';
import { pushDataTrackerEvent } from 'approot/shared/data-tracker/data-tracker-push';

type AddStudentsPushDataTrackingEventProps = {
  targetType:
    | typeof EVENT_TARGET_TYPE_BANNER
    | typeof EVENT_TARGET_TYPE_CTA
    | typeof EVENT_TARGET_TYPE_MODAL;
  targetIdentifier: string;
  eventAction?: typeof EVENT_ACTION_FOLLOW | typeof EVENT_ACTION_ADD;
};

export function addStudentsPushDataTrackingEvent({
  targetType,
  targetIdentifier,
  eventAction = EVENT_ACTION_FOLLOW,
}: AddStudentsPushDataTrackingEventProps): void {
  return pushDataTrackerEvent(EVENT_CATEGORY_ADD_STUDENTS, eventAction, {
    target_type: targetType,
    target_identifier: targetIdentifier,
  });
}
